import React from 'react';

import './terms.css';
import { Trans } from 'react-i18next';

import Link from '../link/Link';

export type TermsAndPolicyProps = {
	name: string;
	termsUrl: string;
	minimal?: boolean;
	policyUrl: string;
	label: string;
};

const TermsAndPolicy: React.FC<TermsAndPolicyProps> = ({ name, label, termsUrl, policyUrl, minimal }) => (
	<Trans
		className="termsAndPolicy"
		components={{
			1: <b>{name}</b>,
			2: <Link href={termsUrl} openInNewTab />,
			3: <Link href={policyUrl} openInNewTab />,
		}}
		i18nKey={minimal ? 'termsAndPolicy' : 'termsAndPolicyAgreement'}
		values={{
			label,
			name,
		}}
	/>
);

export default TermsAndPolicy;
